// extracted by mini-css-extract-plugin
export default {"columns":"columns---ikHyD","primary":"primary---Qb_8c","errorsList":"errorsList---MyurL"};